import { StripeType } from "./stripeType";

// Textos fixos mantidos pela GAM — fonte única, loja NAO edita aqui.
// A loja so personaliza via produto.alerta_texto (curadoria), quando alerta_regulatorio = true.
const ALERTA_FIXO = {
  PRETA: "Venda sob prescrição médica. Atenção, pode causar dependência física ou psíquica.",
  VERMELHA_RETIDA: "Venda sob prescrição médica. Só pode ser vendido com retenção de receita.",
  VERMELHA: "Venda sob prescrição médica.",
};

export function resolverAlertaRegulatorio(produto) {
  if (!produto) return null;

  const hasTarja = !!produto.tarja && produto.tarja !== StripeType.nothing;
  if (!hasTarja) return null;

  const custom = produto.alerta_regulatorio && produto.alerta_texto && produto.alerta_texto.trim();
  if (custom) return custom;

  let texto =
    produto.tarja === StripeType.black
      ? ALERTA_FIXO.PRETA
      : produto.retem_receita
      ? ALERTA_FIXO.VERMELHA_RETIDA
      : ALERTA_FIXO.VERMELHA;

  if (produto.generico) texto += " Medicamento genérico – Lei N.º 9.787/99.";

  return texto;
}
